import React from 'react';
import PropTypes from 'prop-types';
import 'date-fns';
import DateFnsUtils from '@date-io/date-fns';
import { MuiPickersUtilsProvider, KeyboardDatePicker } from '@material-ui/pickers';

class DateCellEditor extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			value: props.value || null,
			updated: false,
			errorMessage: '',
			isError: false
		};
	}

	componentDidMount() {
		const { row, col, rowIndex, columnIndex, onStartEdit } = this.props;
		if (typeof onStartEdit === 'function') {
			onStartEdit(row, col, rowIndex, columnIndex);
		}
	}

	componentWillUnmount() {
		const { onUpdate } = this.props.editorProps;
		const { value, updated } = this.state;

		if (!updated) {
			onUpdate(value);
		}
	}

	getValue = () => this.state.value;

	onChange = value => {
		let errorMessage = '';
		let isError = false;
		if (String(value) === 'Invalid Date') {
			this.setState({ errorMessage: 'Invalid date (dd/mm/yyyy)', isError: true });
			return;
		}

		const { onUpdate } = this.props.editorProps;
		const updated = true;
		this.setState({ value, updated, errorMessage, isError }, () => onUpdate(value));
	};

	onError = () => {
		const { errorMessage, isError } = this.state;
		return { error: isError, message: errorMessage };
	};

	render() {
		const defaultValidate = () => ({ error: false, message: '' });
		const { rowIndex, columnIndex, label, validate = defaultValidate } = this.props;
		const { value, isError } = this.state;
		const key = `date-${rowIndex}-${columnIndex}`;
		const { error, message } = isError ? this.onError() : validate(value);

		return (
			<MuiPickersUtilsProvider utils={DateFnsUtils}>
				<KeyboardDatePicker 
					disableToolbar
					key={key}
					variant="inline"
					format="dd/MM/yyyy"
					margin="normal"
					id={`date-picker-${rowIndex}-${columnIndex}`}
					label={message}
					value={value}
					error={error}
					helperText={label}
					onChange={this.onChange}										
					inputProps={{
						'aria-label': `${label}`
					}}
					KeyboardButtonProps={{
						'aria-label': '	Click to change date'
					}}
				/>
			</MuiPickersUtilsProvider>
		);
	}
}

DateCellEditor.propTypes = {
	value: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
	rowIndex: PropTypes.number.isRequired,
	columnIndex: PropTypes.number.isRequired,
	label: PropTypes.string,
	validate: PropTypes.func
};

DateCellEditor.defaultProps = {
	value: null,
	label: ''
};

export default DateCellEditor;
